import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2719f846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authentication-logout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " Jeste li sigurni da se želite odjaviti? ", -1))
const _hoisted_3 = { class: "form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isDialogVisible = true), ["prevent"]))
    }, "Odjava"),
    _createVNode(_component_el_dialog, {
      title: "Odjava",
      modelValue: _ctx.isDialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "el-button--primary el-button--block",
            "native-type": "submit",
            loading: _ctx.isLoading,
            onClick: _ctx.submitForm
          }, {
            default: _withCtx(() => [
              _createTextVNode("Jesam ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}